import { Controller } from "@hotwired/stimulus"
import { Chart, LineController, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Filler } from "chart.js"

Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Filler)

export default class extends Controller {
  static values = {
    labels: Array,
    activeDays: Array,
    observations: Array,
    actionItems: Array,
    aiGenerations: Array
  }

  connect() {
    this.chart = new Chart(this.element.getContext("2d"), {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: "Jours actifs",
            data: this.activeDaysValue,
            borderColor: "#173A37",
            borderWidth: 2,
            pointRadius: 2,
            tension: 0.3,
            fill: false,
            yAxisID: "yR"
          },
          {
            label: "Observations",
            data: this.observationsValue,
            borderColor: "#2563eb",
            borderWidth: 2,
            pointRadius: 2,
            tension: 0.3,
            fill: false,
            yAxisID: "yL"
          },
          {
            label: "Actions",
            data: this.actionItemsValue,
            borderColor: "#7c3aed",
            borderWidth: 2,
            pointRadius: 2,
            tension: 0.3,
            fill: false,
            yAxisID: "yL"
          },
          {
            label: "IA générée",
            data: this.aiGenerationsValue,
            borderColor: "#E47733",
            borderDash: [4, 3],
            borderWidth: 2,
            pointRadius: 2,
            tension: 0.3,
            fill: false,
            yAxisID: "yL"
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { mode: "index", intersect: false }
        },
        scales: {
          x: {
            ticks: { font: { size: 10 }, maxRotation: 0 },
            grid: { display: false }
          },
          yL: {
            position: "left",
            ticks: { font: { size: 10 } },
            grid: { color: "rgba(0,0,0,0.04)" },
            title: { display: true, text: "Obs / Actions / IA", font: { size: 9 } }
          },
          yR: {
            position: "right",
            ticks: { font: { size: 10 } },
            grid: { display: false },
            title: { display: true, text: "Jours actifs", font: { size: 9 } }
          }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
